import { initializeIcons } from '@fluentui/react';
import { initializeFileTypeIcons } from '@fluentui/react-file-type-icons';
import App from 'App/App';
import { Suspense, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import AppLoader from './components/Loading/AppLoader';
import './index.css';
import localizationService from './services/Localization/i18n';
import { removeUnknownLocalStorageData } from './utils/localstorage';
import {
  beginStartupLoading,
  completeStartupLoading,
  getIsStartupPhaseActive,
  subscribeToStartupPhase,
} from './startupLoader';

//
// Start timer
//
beginStartupLoading();

//
// Initialization
//
localizationService.init();
initializeIcons();
initializeFileTypeIcons();
removeUnknownLocalStorageData();

//
// Finish timer
//
completeStartupLoading();

//
// Boot loader helpers
//
function useStartupPhaseActive(): boolean {
  const [active, setActive] = useState(getIsStartupPhaseActive());

  useEffect(() => {
    return subscribeToStartupPhase(() => {
      setActive(getIsStartupPhaseActive());
    });
  }, []);

  return active;
}

function StartupAwareFallback() {
  const startupPhaseActive = useStartupPhaseActive();

  if (startupPhaseActive) {
    return null;
  }

  return <AppLoader />;
}

//
// Main render
//
ReactDOM.render(
  <Suspense fallback={<StartupAwareFallback />}>
    <App />
  </Suspense>,
  document.getElementById('root'),
);
